import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { userGroupsKeys } from './queryKeys';
import { deleteRoleName } from 'api/userGroups.service';

export const useRoleDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore();

  const { isPending, mutate } = useMutation({
    mutationFn: (info: { roleId: string }) => {
      setLoading();

      return deleteRoleName(info.roleId);
    },
    onSuccess: () => {
      toast.success('Role has been deleted successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      removeLoading();
      queryClient.invalidateQueries({
        queryKey: userGroupsKeys.all,
      });
    },
  });

  return { isLoading: isPending, mutate };
};
